import { loadStripe } from '@stripe/stripe-js';

// ⚠️ WARNING: Secret keys should NEVER be stored in frontend code in production!
// This is only for temporary development. Move to backend before production deployment.
export const STRIPE_SECRET_KEY = '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';

// Stripe publishable key
export const stripePromise = loadStripe('pk_live_51R5wfuEDmOWLdItO2eRhUlQsgikUMVZ0RMSqiZUVseb4vPfrdWK2w09RWcct4qIuHZvqXc6su8KhCG1fkaRcNGSA00fh4ENtie');

